import { HeaderLevel } from '../Header';

import { ParagraphListListItem, ParagraphListNodeItem, ParagraphListSize } from './types';

/**
 * Проверяем что item не простая строка. Маркером InnerParagraphListProps является наличие поля items внутри
 * @param item элемент списка
 * @returns boolean
 */
export function isInnerParagraphListItem(
    item: ParagraphListNodeItem | ParagraphListListItem,
): item is ParagraphListListItem {
    // Исправить при редактировании. Автоматический игнор, см. DIRECT-193196.
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions -- см. выше
    return Boolean((item as ParagraphListListItem)?.items);
}

/** Обьект, используемый для маппинга размера ParagraphList в размер заголовка */
export const paragraphListHeaderLevels: Record<ParagraphListSize, HeaderLevel> = {
    m: 'h4',
    s: 'h5',
} as const;
